import { curry, property } from 'lodash-es';
import { compose } from 'redux';
import { matchers } from '../http-request';
import { find } from '../utils';

export const current = state => [...state.error];

const findResourceError = matcher =>
  compose(
    find(matchers.core.isRequestResultErrorFor(matcher)),
    current
  );

export const message = curry((matcher, state) =>
  compose(
    property('payload.message'),
    findResourceError(matcher)
  )(state)
);

export const payload = curry((matcher, state) =>
  compose(
    property('payload'),
    findResourceError(matcher)
  )(state)
);

export const statusCode = curry((matcher, state) =>
  compose(
    matchers.ng1.responseStatus,
    findResourceError(matcher)
  )(state)
);

const resposePayloadCode = state => {
  const currentError = current(state)[0];
  const payload = currentError && currentError.payload;
  return payload ? payload.code : '';
};
const ACCESS_LOCKED = 'ACCESS_LOCKED';

export const accessIsLocked = state =>
  resposePayloadCode(state) === ACCESS_LOCKED;
